import { IDrawableItem } from "../../../domain/document/items";

export interface IDrawableItemEditable {
  editingSource: IDrawableItem;
  writeProperty(write: (source: any) => void): void;
  inputableElement?: HTMLInputElement;
}

export function instanceOfIDrawableItemEditable(instance: any): instance is IDrawableItemEditable {
  return instance
    && (instance.editingSource !== undefined)
    && (instance.writeProperty !== undefined);
}
